var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-item',{attrs:{"item":_vm.item,"count":_vm.count,"dense":_vm.dense,"icon":"kit"},on:{"click":function($event){return _vm.clicked()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }